import { ChangeRepuestosDTO } from '@/application/dto/repuesto/ChangeRepuestosDTO';
import { IRepuestoRepository } from '@/domain/repositories/IRepuestoRepository';

export class PatchRepuestoUseCase {
  constructor(private readonly repository: IRepuestoRepository) {}

  async execute(id: string, data: ChangeRepuestosDTO): Promise<void> {
    return this.repository.change(id, { estado: Number(data.estado) });
  }
}
